export default api => {
	api.addResource("login");
	api.addResource("logout");
};
